// extracted by mini-css-extract-plugin
export default {"button":"order_list_button__3Pb1R"};